<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <div>
      <v-btn icon="mdi-refresh" density="comfortable" @click="refreshAllSecurityPrices()" class="ml-2"></v-btn>
    </div>
  </v-row>
  <v-row v-for="portfolio in securities_summary_data" :key="portfolio.id">
    <v-col cols="12" md="12">
      <v-card link>
        <v-card-item>
          <template v-slot:prepend>
            <img
              :src="getBrokerLogoPath(portfolio.institution)"
              :alt="portfolio.institution"
              style="width: 48px; height: 48px; object-fit: contain; padding: 4px; cursor: pointer;"
              @click="routeToBrokerAccount(portfolio.id)"
            />
          </template>
          <v-card-title class="text-left" @click="routeToBrokerAccount(portfolio.id)">{{ portfolio.account_name }}</v-card-title>
          <v-card-subtitle class="text-left" @click="routeToBrokerAccount(portfolio.id)">{{ portfolio.institution }}</v-card-subtitle>
          <template v-slot:append>
            <v-btn icon="mdi-cog-outline" variant="text" density="comfortable" @click.stop="openEditModal(portfolio)" title="link cash account"></v-btn>
          </template>
        </v-card-item>
        <v-divider></v-divider>
        <v-card-text @click="routeToBrokerAccount(portfolio.id)">
          <v-container>
            <v-row>
              <v-col cols="12" md="4" >
                <p class="font-weight-light">market value</p>
                <Transition mode="out-in" name="fade-in">
                  <p class="values_text">{{ portfolio.base_currency.total_market_value.toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</p>
                </Transition>
              </v-col>
              <v-col cols="12" md="4">
                <p class="font-weight-light">cost base</p>
                <Transition mode="out-in" name="fade-in">
                  <p class="values_text">{{ portfolio.base_currency.total_portfolio_cost_base.toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</p>
                </Transition>
              </v-col>
              <v-col cols="12" md="4">
                <p class="font-weight-light">portfolio % yield</p>
                <p class="values_text">{{ portfolio.forecast_yield_pct }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <p class="font-weight-light">total profit</p>
                <Transition mode="out-in" name="fade-in">
                  <p :class="getTextColour(portfolio.base_currency.total_portfolio_profit)" class="values_text">{{ portfolio.base_currency.total_portfolio_profit.toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</p>
                </Transition>
              </v-col>
              <v-col cols="12" md="4">
                <p class="font-weight-light">total profit %</p>
                <p :class="getTextColour(portfolio.base_currency.total_portfolio_profit_pct)" class="values_text">{{ (portfolio.base_currency.total_portfolio_profit_pct).toLocaleString("en", {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
              </v-col>
              <v-col cols="12" md="4">
                <p class="font-weight-light">portfolio $ yield</p>
                <Transition mode="out-in" name="fade-in">
                  <p class="values_text">{{ (portfolio.base_currency.total_portfolio_yield_value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</p>
                </Transition>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <BrokerAccountEditModalPopup
    :show="showEditModal"
    :brokerAccountId="selectedBrokerAccountId"
    @close="showEditModal = false"
  />
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';
import BrokerAccountEditModalPopup from './modals/BrokerAccountEditModalPopup.vue';

export default {
  components: {
    BrokerAccountEditModalPopup,
  },
  data() {
    return {
      securities_summary_data: [],
      loading: true,
      loading: {
        securities_summary_data: true,
      },
      showEditModal: false,
      selectedBrokerAccountId: null,
    };
  },
  async created() {
    this.getSecuritiesSummaryData();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
      
        {
          title: 'securities summary',
          disabled: true,
          href: '/securitiessummary'
        },
      ];
    },
    hasForeignCurrencyTxns() {
      return this.securities_summary_data.some(item => item.foreign_currency_txns === 1);
    },

  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async getSecuritiesSummaryData(){
      try {
      const response  = await axios.get("/securities/portfolios/summary",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.securities_summary_data = response.data;
          this.loading.securities_summary_data = false;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load securities summary' });
      }
    },
    routeToBrokerAccount(id){
      this.$router.push('/brokeraccounts/' + id)
    },
    openEditModal(portfolio) {
      this.selectedBrokerAccountId = portfolio.id;
      this.showEditModal = true;
    },
    async refreshAllSecurityPrices(){
      try {
        const { data } = await axios.request({
          url: "/securities/prices/",
          method: "POST",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
          }
        });
          this.getSecuritiesSummaryData(); // refresh local values
      } catch (error) {
        this.showSnackbar({ message: 'Failed to refresh security prices' });
      }
    },
    getTextColour(value){
      if(value < 0){
        return 'red_text';
      }
      else if(value > 0){
        return 'green_text';
      }
    },
    getBrokerLogoPath(institution) {
      const key = (institution || '').toLowerCase().trim();
      const map = {
        'commsec': 'commsec',
        'comsec': 'commsec',
        'nab trade': 'nabtrade',
        'interactive brokers': 'interactive-brokers',
      };
      const file = map[key];
      return file ? `/broker-logos/${file}.svg` : `/broker-logos/default.svg`;
    },
  }
  
};

</script>


<style scoped>
.text-h4 {
  font-family: 'Courier New', Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.fade-in-enter-active {
  transition: opacity 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.fade-in-leave-active {
  transition: opacity 225ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}

.green_text{
  color: green;
}

.red_text{
  color: red;
}

.values_text{
  font-size: 2.5em;
  font-weight: 300;
}
</style>